"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setImageQuality = function (useSourceFormat, quality) {
    if (useSourceFormat) {
        return '';
    }
    if (!useSourceFormat && !quality) {
        return 'q_auto';
    }
    return quality;
};
exports.getCloudinaryTransforms = function (_a) {
    var dimensions = _a.dimensions, quality = _a.quality, rounded = _a.rounded, color = _a.color, useSourceFormat = _a.useSourceFormat;
    var params = [
        rounded && 'r_max',
        rounded ? !useSourceFormat && 'f_png' : !useSourceFormat && 'f_auto',
        exports.setImageQuality(useSourceFormat, quality),
        !color && 'c_thumb',
        color && "c_scale,co_rgb:" + color + ",e_colorize:100",
        dimensions || '',
        'fl_lossy',
        'fl_progressive',
    ];
    return params.filter(Boolean).join(',');
};
//# sourceMappingURL=cloudinary.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/web-fns/dist/cloudinary/cloudinary.js
// module id = 1867
// module chunks = 0